import { render } from "./Brief.vue?vue&type=template&id=667e3302"
import script from "./Brief.vue?vue&type=script&lang=js"
export * from "./Brief.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__